module.exports = "/images/user.svg?30c59f9643860f465085329abaa97684";